import styles from "./styles.css";
import React from "react";
import {TYPE_OF_SALE} from "../constants";
import PropTypes from "prop-types";

const SelectionFixedVoice = ({formik}) => {
  const {errors, setFieldValue, values, touched, setTouched, handleBlur} = formik
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  const specificStyle = isSafari ? styles.custom_radio_safari : styles.custom_radio_default;

  const handleChange = (name, value) => {
    setFieldValue(name,value, true)
    setTouched({...touched,[name]: true });

    const updatedErrors = { ...errors };
    if (updatedErrors[name]) {
      delete updatedErrors[name];
      formik.setErrors(updatedErrors);
    }
  }

  return (
    <div>
      <div className={`${styles.line_input} ${styles.custom_radio_default}`}>
        <div className={`${styles.first_input} ${specificStyle}`}>
          <input
            tabIndex={1}
            id="newSale"
            name="typeOf"
            type="radio"
            value="Nova venda"
            onChange={(e) => {handleChange("typeOf", e.target.value)}}
            checked={values.typeOf === TYPE_OF_SALE.NEW_SALE.TITLE}
            onBlur={handleBlur}
          />
          <label htmlFor="newSale">Nova</label>
        </div>

        <div className={`${specificStyle}`}>
          <input
            tabIndex={2}
            id="portability"
            name="typeOf"
            type="radio"
            value="Portabilidade"
            onChange={(e) => {handleChange("typeOf",e.target.value)}}
            checked={values.typeOf === TYPE_OF_SALE.PORTABILITY.TITLE}
            onBlur={handleBlur}
          />
          <label htmlFor="portability">Portabilidade</label>
        </div>
      </div>
    </div>
  )
}

SelectionFixedVoice.propTypes = {
  formik: PropTypes.object.isRequired,
}

export default SelectionFixedVoice



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/Pages/NewSale/components/SelectionFixedVoice.js